import React, { useState } from "react";
import { IState, IUserRegistrationFragmetProps, Property, SelectOptions } from "./UserRegistrationForm.panel";
import styled from "styled-components";
import Multiselect from "multiselect-react-dropdown";
import { InputVariant, InputView } from "common/views/input/Input.view";
import Label from "core/components/label/Label";
import { Checkbox } from "@blueprintjs/core";

const StyledDiv = styled.div`
	 {
		display: flex;
		justify-content: flex-start;
		padding: 0.5em;
		width: 50%;
		& > span {
			flex: 2;
		}
		& > div {
			flex: 1;
		}
	}
`;

const StyledCheckbox = styled.div`
	 {
		display: flex;
		justify-content: flex-start;
		padding: 0.5em;
		flex:1
	}
`;

const StyledMultiElement = styled.div`
	 {
		display: flex;
		padding: 0.5em;
		flex-direction: column;
	} & > div{
		display: flex;
		flexDirection: row;
		justifyContent:space-between;
	}
`;

const StyledSelect= styled.select`{
	flex:1
	min-width: 15ch;
	max-width: 30ch;
	border-radius: 0.25em;
	font-size: 1rem;
	cursor: pointer;
	height: 40px;
	background-color: #ffffff;
	background-image: linear-gradient(to top, #f9f9f9, #fff 33%);
  }`

const CommonInput = ({
	Ikey,
	name,
	onChange,
	variant,
	labelDefault,
	placeholder,
	userPropertyValue
}) => {
	function _onChange(event){
		const target = event.target;
        const targetvalue = target.type === 'checkbox' ? target.checked : target.value;
		const propsValue= {
			value: targetvalue,
			property: userPropertyValue
		}
		onChange(name, propsValue)
	}

	if (Ikey)
		return (
			<React.Fragment>
				<StyledDiv>
					<Label k={Ikey} v={labelDefault} />
					<InputView
						viewKey={Ikey}
						name={name}
						onChange={_onChange}
						variant={variant}
						placeholder={placeholder}
					/> 
				</StyledDiv>
			</React.Fragment>

		);
	return null;
};


const CommonCheckbox = ({
	Ikey,
	name,
	onChange,
	labelDefault,
	value,
	state,
	userPropertyValue
}) => {
	 function _onChange(event){
		const target = event.target;
        const targetvalue = target.type === 'checkbox' ? target.checked : target.value;
		const propsValue= {
			value: targetvalue+"",
			property: userPropertyValue
		}
		onChange(name, propsValue)
	}

	if (Ikey)
		return (
			<StyledDiv style={{marginTop:15, marginLeft:5}}>
					<Label k={Ikey} v={" "+labelDefault}/>	
					<StyledCheckbox>
						<Checkbox
							checked= {state && state.properties && state.properties[name] &&state.properties[name].value? state.properties[name].value: false}
							name={name}
							onChange={_onChange}/>
					</StyledCheckbox>
				</StyledDiv>		
		);
	return null;
};

const CommonCheckboxs = ({
	Ikey,
	name,
	onChange,
	labelDefault,
	value,
	state,
	userPropertyValue
}) => {
	let index=0;
	const [checks, setChecks] = useState({});
	if (Ikey)
		{
			 let _onChange=(event, targetName) =>{
				let selectVal=[];
				const target = event.target;
				const targetvalue = target.type === 'checkbox' ? target.checked : target.value;
				let val= {...checks};
				val[targetName]= targetvalue;
				
				Object.keys(val).map(key => {
					if(val[key]) selectVal.push(key)
				});
				
				setChecks({...val});
				const propsValue= {
					value: selectVal,
					property: userPropertyValue
				}
				onChange(name, propsValue)
			}

			return (
				<StyledDiv style={{marginTop:15, marginLeft:5}}>
						<Label k={Ikey} v={labelDefault}/>	
						<StyledMultiElement>
							{
								value.map(item => {
									return <div key={Ikey+""+ index++}>
												<Checkbox checked= {checks && checks[item]? checks[item]: false}
															name={item} onChange={(e) =>
															{_onChange(e, item)}
																		}/>		
												<Label k={Ikey} v={item} />	
									</div>
								})
							}
						</StyledMultiElement>
				</StyledDiv>		
			);
		}
	return null;
};

const CommonRadios = ({
	Ikey,
	name,
	onChange,
	labelDefault,
	value,
	state,
	userPropertyValue
}) => {
	let index= 0;
	const [check, setChecked] = useState("a");

	let _onChange=(targetName) =>{
		let val: string= targetName;
		setChecked(val);

		const propsValue= {
			value: val,
			property: userPropertyValue
		}
		onChange(name, propsValue)
	}
	
	if (Ikey)
		{
			return (
				<StyledDiv style={{marginTop:15, marginLeft:5}}>
						<Label k={Ikey} v={labelDefault}/>

						<StyledMultiElement>
							{
								value.map((item: string) => {
									return <div key={Ikey+""+ index++}>
											<input type="radio" 
													value={item}
													checked= {check== item? true: false}
													name={item}
													 onChange={(e) => {_onChange(item)} }/>

											<Label k={Ikey} v={item} />	
									</div>
								})
							}
						</StyledMultiElement>
				</StyledDiv>		
			);
		}
	return null;
};

const CommonMultiselect = ({
	Ikey,
	labelDefault,
	options,
	displayValue,
	onSelect,
	userPropertyValue,
	name
}) => {
	
	function _onChange(selectList){
		let selectValue = selectList.map(({ value }) => value)
		const propsValue= {
			value: selectValue,
			property: userPropertyValue
		}
		onSelect(name, propsValue)
	}
	if (Ikey)
		return (
			<React.Fragment>
				<StyledDiv>
					<Label k={Ikey} v={labelDefault} />
						<Multiselect
							options={options}
							displayValue={displayValue}
							onSelect={(selectList:SelectOptions[])=>{ _onChange(selectList)}}
						/>
				</StyledDiv>
			</React.Fragment>
		);
	return null;
};



const CommonSelect = ({
	Ikey,
	labelDefault,
	options,
	onSelect,
	userPropertyValue,
	name
}) => {
	let index=0;
	const [select, setSelect]= useState({label:"", value: ""});

	function _onChange(event){
		let value= event.target.value;
		const propsValue= {
			value: value,
			property: userPropertyValue
		}
		setSelect({label: value, value: value})
		onSelect(name, propsValue)
	}
	if (Ikey)
		return (
			<React.Fragment>
				<StyledDiv>
					<Label k={Ikey} v={labelDefault} />
					<StyledSelect onChange={_onChange} value={select && select['value']}>
						{
							options&& options.length>0&& options.map(item => {
								return <option key= {Ikey+""+index} value={item.value}>{item.label}</option>
							})
						}
					</StyledSelect>
				</StyledDiv>
			</React.Fragment>
		);
	return null;
};

interface IElement{
	userPropertyValue: Property;
	onChange: (e: any, selectList?:SelectOptions[], name?:string) => void;
	state: IState;
}

const getUserPropertyValueObj= (userPropertyValue: Property) =>{
	let obj={};
	Object.keys(userPropertyValue).map(key=>{
		if(key ==="propsName") obj['name']= userPropertyValue[key];
		else obj[key]= userPropertyValue[key];
	})
	return obj;
}

const Element =(props: IElement)=>{
	const {userPropertyValue, onChange, state}= props;

	if(userPropertyValue.type== 'string' && !userPropertyValue.hidden){
		return <CommonInput Ikey={userPropertyValue.propsName} 
					name={userPropertyValue.displayName}
					onChange= {onChange} 
					variant={InputVariant.TEXT} 
					labelDefault= {userPropertyValue.displayName} 
					placeholder= {userPropertyValue.displayName}
					userPropertyValue={getUserPropertyValueObj(userPropertyValue)} />

	} else if(userPropertyValue.type== 'boolean' && !userPropertyValue.hidden){
		return <CommonCheckbox Ikey={userPropertyValue.propsName}
					name={userPropertyValue.displayName}
					onChange={onChange} 
					labelDefault= {userPropertyValue.displayName}
					value= {true} 
					state= {state} 
					userPropertyValue={getUserPropertyValueObj(userPropertyValue)} />

	} else if(userPropertyValue.type== 'list:multi' && !userPropertyValue.hidden){
		let options=[];
		if(userPropertyValue.properties) {
			userPropertyValue.properties.split(",").map(value => {
				options.push({label: value, value: value})
			})
		}
		return <CommonMultiselect
						Ikey={userPropertyValue.propsName}
						name={userPropertyValue.propsName}
						labelDefault={userPropertyValue.displayName}
						onSelect={onChange}
						options={options}
						displayValue="label"
						userPropertyValue={getUserPropertyValueObj(userPropertyValue)}/>

	} else if(userPropertyValue.type== 'list' && !userPropertyValue.hidden){
		let options=[];
		if(userPropertyValue.properties) {
			userPropertyValue.properties.split(",").map(value => {
				options.push({label: value, value: value})
			})
		}
		return <CommonSelect 
						Ikey={userPropertyValue.propsName}
						name={userPropertyValue.propsName}
						labelDefault={userPropertyValue.displayName}
						onSelect={onChange}
						options={options}
						userPropertyValue={getUserPropertyValueObj(userPropertyValue)}/>

	}else if(userPropertyValue.type== 'list:multi:button' && !userPropertyValue.hidden){
		let options=[];
		if(userPropertyValue.properties) {
			userPropertyValue.properties.split(",").map(value => {
				options.push(value);
			})
		}
		return <CommonCheckboxs Ikey={userPropertyValue.propsName}
					name={userPropertyValue.displayName}
					onChange={onChange} 
					labelDefault= {userPropertyValue.displayName}
					value= {options}
					state= {state} 
					userPropertyValue={getUserPropertyValueObj(userPropertyValue)}/>
	}   else if(userPropertyValue.type== 'list:button' && !userPropertyValue.hidden){
		let options=[];
		if(userPropertyValue.properties) {
			userPropertyValue.properties.split(",").map(value => {
				options.push(value);
			})
		}
		return <CommonRadios Ikey={userPropertyValue.propsName}
					name={userPropertyValue.displayName}
					onChange={onChange} 
					labelDefault= {userPropertyValue.displayName}
					value= {options}
					state= {state}
					 userPropertyValue={getUserPropertyValueObj(userPropertyValue)}/>

	} else return null;
}

export const CustomDisplayFragments=(props: IUserRegistrationFragmetProps) =>{
	const {data, onCustPropChange} = props;
	const {userPropertyValue}= data;
	return(
		<React.Fragment>
			{
				userPropertyValue.map(item=>{
					return <Element key ={item.propsName} userPropertyValue={item} onChange= {onCustPropChange} state= {props.state}/>
				})  
			}
		</React.Fragment>
	);
	  
                
}




// WEBPACK FOOTER //
// ./src/panels/userRegistration/customDisplayFragments.tsx